<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Indicadores APS"
            description="Indicadores do componente qualidade para eSF, eAP, eSB e eMulti"
            url="/dashboard"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/p/h/8cj1fp4-2631/2fc51123cde0aa5/8cj1fp4-3571"
            pageIdentifier="indicadores-aps"
            :enableBadgeModalInformacao="
              Number($store.state.permissoesRaw?.indicadores_aps_ajuda || 0) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.indicadores_aps_ajuda || 0
            "
            keyAjudaModalInformacao="indicadores_aps_ajuda"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <div
                class="ribbon"
                v-if="item.featured !== undefined && item.featured == true"
              >
                <span>BETA</span>
              </div>

              <span
                v-if="$store.getters.getQuantidadeAjuda(item.key) > 0"
                class="item-badge"
              >
                {{ $store.getters.getQuantidadeAjuda(item.key) }}
              </span>

              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import ResultadoIsf from '@/components/icons/IndicadoresAps/ResultadoIsf.vue'
import ResultadoIndicadores from '@/components/icons/IndicadoresAps/ResultadoIndicadores.vue'
import DesempenhoPorEquipe from '@/components/icons/IndicadoresAps/DesempenhoPorEquipe.vue'
import SaudeBucal from '@/components/icons/IndicadoresAps/SaudeBucal.vue'
import eSFeAP from '@/components/icons/IndicadoresAps/eSFeAP.vue'
import eMulti from '@/components/icons/IndicadoresAps/eMulti.vue'
import DivergenciaDadosIndicadoresIcon from '@/components/icons/IndicadoresAps/DivergenciaDadosIndicadoresIcon.vue'

export default {
  name: 'IndicadoresAps',
  metaInfo: {
    title: 'Indicadores APS',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    ResultadoIsf,
    ResultadoIndicadores,
    DesempenhoPorEquipe,
    SaudeBucal,
    eSFeAP,
    eMulti,
    DivergenciaDadosIndicadoresIcon,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.indicadores_aps
      ) {
        const dataClone = [...this.$store.state.permissoes.indicadores_aps]
        return dataClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  data() {
    return {}
  },
  methods: {
    /**
     * Retorna a cor do ribbon do card
     *
     * @param item
     * @returns {string}
     */
    getRibbonColor(item) {
      switch (item.text) {
        case 'ESF':
          return 'blue'
          break
        case 'eSB':
          return 'green'
          break
        case 'eMulti':
          return 'orange'
          break
        default:
          return 'blue'
          break
      }
    },
  },
}
</script>

<style></style>
